import { Component, inject } from '@angular/core';
import { InactivityService } from '../../services/inactivity.service';

@Component({
  selector: 'app-inactivity-modal',
  standalone: true,
  templateUrl: './inactivity-modal.html',
  styleUrls: ['./inactivity-modal.scss']
})
export class InactivityModalComponent {
  inactivityService = inject(InactivityService);

  get formattedTime(): string {
    const s = this.inactivityService.remainingSeconds();
    const min = Math.floor(s / 60).toString().padStart(2, '0');
    const sec = (s % 60).toString().padStart(2, '0');
    return `${min}:${sec}`;
  }

  onContinue(): void {
    this.inactivityService.continueSession();
  }

  onClose(): void {
    this.inactivityService.closeSession();
  }
}
